<template>
    <div>         
        <!-- CONTENIDO PRINCIPAL -->
         <div class="container contenido_principal" style="margin-bottom:5rem">
            <boton-atras :nombre_ruta="'informacion'"></boton-atras>

             <div>
                <div>
                    <h6 class="subtitulo mb-2">FOPROVEP.- Coberturas</h6>
                    <div class="lineaNegra"></div><div class="mt-1 mb-2 lineaNegra2"></div>
                <h5 class="mt-5">Daños materiales y pérdidas totales a consecuencia de:</h5>
                </div>
                <ul class="parrafo-contenido">
                   <li>Colisiones y vuelcos.</li>
                   <li>Rotura de parabrisas, aletas y medallón.</li>
                   <li>Incendio siempre que este no se produzca por falla mecánica, explosión y rayo.</li>
                   <li>Ciclón, huracán, granizo, terremoto, derrumbe, caída de árboles o sus ramas.</li> 
                </ul>
                <h5>Robo</h5>    
                <h5>Responsabilidad civil.</h5>              
            </div>
             
            
         </div>
    </div>
</template>
<script>
import botonAtras from './../../button-atras'
export default {
    data: function(){
        return{
            // variables
        }
    },
    components:{
        botonAtras
    }
}
</script>

<style scoped>

@media only screen and (max-device-width : 900px) {
    .subtitulo{ 
        font-size: 1.4rem !important;
        margin-top: 1.6rem !important;
    }
    .contenido_principal h5{ font-size: 1rem; }
    .parrafo-contenido{ font-size: 1em !important; }
}

.parrafo-contenido{
    font-size: 1.3em;
    line-height: 1.8em;
}

</style>